import { render, staticRenderFns } from "./ClientActionPrioritySelect.vue?vue&type=template&id=48b98d9f&"
import script from "./ClientActionPrioritySelect.vue?vue&type=script&lang=js&"
export * from "./ClientActionPrioritySelect.vue?vue&type=script&lang=js&"
import style0 from "./ClientActionPrioritySelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports